import { CalloutCardCollectionDetailPage } from "@lib/kontent/models/CalloutCardCollectionDetailPage"
import Link from "next/link"
import React, { FC } from "react"
import * as S from "./CalloutCard.elements"
import { TitleM } from "@components/Typography"
import { LinkButton } from "@components/Buttons"
import { getKontentImage } from "@lib/kontent"

type CalloutCardProps = CalloutCardCollectionDetailPage

export const CalloutCard: FC<CalloutCardProps> = ({
  title,
  link_title,
  link_url,
  image,
  text_position,
  text_color,
}) => {
  const alignTop = text_position.value[0].codename === "top"
  const isColorLight = text_color.value[0].codename === "light"
  const backgroundImage = image.value[0]?.url

  return (
    <Link href={link_url.value} passHref>
      <S.Anchor
        alignTextTop={alignTop}
        backgroundUrl={getKontentImage(backgroundImage, {
          width: 600,
        })}
      >
        <S.Content isColorLight={isColorLight}>
          <TitleM as="span">{title.value}</TitleM>
          <LinkButton data-link-button>{link_title.value}</LinkButton>
        </S.Content>
      </S.Anchor>
    </Link>
  )
}
